module.exports = __webpack_public_path__ + "img/s-class.733799f4.jpg";